<!-- eslint-disable prettier/prettier -->
@switch (columnName) {
  @case ('signedOn') {
    {{ element.signedOn | date }}
  }
  @case ('signedBy') {
    {{ element.adminSignedByName }}
  }
  @case ('status') {
    <app-ui-pill [name]="PLANNED_ACTIVITY_SIGN_OFF_PERIOD_STATUS[element.status]"></app-ui-pill>
  }
  @case ('name') {
    {{ element.user?.firstName }} {{ element.user?.lastName }} {{ element.userFullName }}
  }
  @case ('from') {
    {{ element.from | date }}
  }
  @case ('to') {
    {{ element.to | date }}
  }
  @case ('signedBy') {
    {{ element.signedBy }}
  }
  @case ('department') {
    {{ element.department?.name }}
  }
  @case ('departments') {
    @for (department of element.departments; track $index) {
      <div>
        {{ department?.name }}
      </div>
    }
    @for (departmentGroup of element.departmentGroups; track $index) {
      <div>
        {{ departmentGroup?.name }}
      </div>
    }
  }
  @default {
    <app-default-cell [element]="element" [columnName]="columnName"></app-default-cell>
  }
}
